// extracted by mini-css-extract-plugin
export default {"modal":"ImageViewModal_modal__0YjFT","closeButton":"ImageViewModal_closeButton__0bMgV","imageContainer":"ImageViewModal_imageContainer__+-I1X","image":"ImageViewModal_image__Wnf1N"};